import React from 'react';
import { mrkdwnToHtml } from '../../../../../../utils/slackMrkdwn';

interface SlackPreviewProps {
    channel: string;
    text: string;
}

const SlackPreview: React.FC<SlackPreviewProps> = ({ channel, text }) => {
    const time = new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
    return (
        <div className="rounded-xl border border-gray-200 dark:border-slate-700 bg-white overflow-hidden shadow-sm">
            <div className="flex items-center gap-2 px-4 py-2.5 border-b border-gray-200 bg-white">
                <span className="text-gray-400">#</span>
                <span className="text-sm font-bold text-gray-900">{channel || 'canal-não-definido'}</span>
            </div>
            <div className="px-4 py-4 flex gap-3 bg-white">
                <span className="w-9 h-9 rounded-md bg-teal-500 text-white text-xs font-bold flex items-center justify-center shrink-0">AG</span>
                <div className="flex-1 min-w-0">
                    <div className="flex items-baseline gap-1.5">
                        <span className="text-[15px] font-bold text-gray-900">Agrolend Backoffice</span>
                        <span className="text-[10px] font-semibold uppercase bg-gray-200 text-gray-600 rounded px-1">App</span>
                        <span className="text-xs text-gray-500">{time}</span>
                    </div>
                    <div
                        className="slack-message text-[15px] leading-[1.46] text-gray-900 break-words [&_.slack-link]:text-[#1264A3] [&_.slack-link:hover]:underline [&_.slack-code]:bg-gray-100 [&_.slack-code]:text-[#E01E5A] [&_.slack-code]:border [&_.slack-code]:border-gray-200 [&_.slack-code]:rounded [&_.slack-code]:px-1 [&_.slack-code]:text-[12px] [&_.slack-pre]:bg-gray-50 [&_.slack-pre]:border [&_.slack-pre]:border-gray-200 [&_.slack-pre]:rounded [&_.slack-pre]:p-2 [&_.slack-pre]:text-[12px] [&_.slack-pre]:whitespace-pre-wrap [&_.slack-quote]:block [&_.slack-quote]:border-l-4 [&_.slack-quote]:border-gray-300 [&_.slack-quote]:pl-2"
                        dangerouslySetInnerHTML={{ __html: mrkdwnToHtml(text) }}
                    />
                </div>
            </div>
        </div>
    );
};

export default SlackPreview;
